import React from 'react'
import styled from 'styled-components'
import DefaultLayout from '../components/DefaultLayout'

const Favourite = () => {
  return (
    <div className="favourite">
        <DefaultLayout>
            <Title>
                Favourite Items
            </Title>
            <Grid>

            </Grid>
            <Empty>
                Empty 
            </Empty>
        </DefaultLayout>
    </div>
  )
}

export default Favourite

const Title = styled.h1`
    text-align: center;
    padding: 20px 0;
    background-color: #f0ebe6;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 30px;
`
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

const Empty = styled.div`
    height: 500px;
    display: grid;
    place-content: center;
    font-size: 22px;
    font-weight: 500;
`